import { Box, Typography } from '@mui/material';
import React from 'react';

const TimeCounter = () => {
    const [timerDays, setTimerDays] = React.useState('00');
    const [timerHours, setTimerHours] = React.useState('00');
    const [timerMinutes, setTimerMinutes] = React.useState('00');
    const [timerSeconds, setTimerSeconds] = React.useState('00');
    let interval = React.useRef();
    const startTimer = () => {
        const countdownDate = new Date('April 16, 2022 00:00:00').getTime();

        interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = countdownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (distance < 0) {
                clearInterval(interval.current);
            } else {
                setTimerDays(days);
                setTimerHours(hours);
                setTimerMinutes(minutes);
                setTimerSeconds(seconds);
            }
        }, 1000);
    }

    React.useEffect(() => {
        startTimer()
        return () => {
            clearInterval(interval.current);
        }
    });

    return (
        <div>
            <Box sx={{ py: { xs: '15px', sm: '18px', md: '26px', lg: '34px' } }}>
                <Box sx={{ py: { xs: '8px', sm: '14px', md: '18px', lg: '22px' }, px: { xs: '26px', sm: '36px', md: '46px', lg: '56px' }, background: 'linear-gradient(91.57deg, #332EC4 0.14%, #5867FE 83.18%)', width: { xs: '300px', sm: '530px', md: '747px', lg: '966px', xl: '70%' }, mx: 'auto', borderRadius: '6px', boxShadow: { xs: '-4px 6px 12px rgba(86, 81, 236, 0.5)', md: '-6px 10px 16px rgba(86, 81, 236, 0.5)', lg: '-8px 14px 22px rgba(86, 81, 236, 0.5)' } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '11px', sm: '18px', md: '26px', lg: '34px' }, lineHeight: { xs: '18px', sm: '33px', md: '48px', lg: '57px' }, textAlign: 'center', color: '#FFFFFF' }}>16th April</Typography>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '9px', sm: '14px', md: '22px', lg: '30px' }, lineHeight: { xs: '10px', sm: '28px', md: '44px', lg: '57px' }, textAlign: 'center', color: '#FFFFFF' }}>Quantally Pre-sale</Typography>
                        </Box>
                        {/* timer */}
                        <Box>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '15px', sm: '25px', md: '35px', lg: '45px' }, lineHeight: { xs: '22px', sm: '35px', md: '48px', lg: '67px' }, textAlign: 'center', color: '#FFFFFF' }}>{timerDays}</Typography>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '6px', sm: '10px', md: '14px', lg: '18px' }, lineHeight: { xs: '9px', sm: '15px', md: '21px', lg: '27px' }, textAlign: 'center', color: '#FFFFFF' }}>Days</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '15px', sm: '25px', md: '35px', lg: '45px' }, lineHeight: { xs: '22px', sm: '35px', md: '48px', lg: '67px' }, textAlign: 'center', color: '#FFFFFF' }}>{timerHours}</Typography>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '6px', sm: '10px', md: '14px', lg: '18px' }, lineHeight: { xs: '9px', sm: '15px', md: '21px', lg: '27px' }, textAlign: 'center', color: '#FFFFFF' }}>Hours</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '15px', sm: '25px', md: '35px', lg: '45px' }, lineHeight: { xs: '22px', sm: '35px', md: '48px', lg: '67px' }, textAlign: 'center', color: '#FFFFFF' }}>{timerMinutes}</Typography>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '6px', sm: '10px', md: '14px', lg: '18px' }, lineHeight: { xs: '9px', sm: '15px', md: '21px', lg: '27px' }, textAlign: 'center', color: '#FFFFFF' }}>Minutes</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '15px', sm: '25px', md: '35px', lg: '45px' }, lineHeight: { xs: '22px', sm: '35px', md: '48px', lg: '67px' }, textAlign: 'center', color: '#FFFFFF' }}>{timerSeconds}</Typography>
                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '6px', sm: '10px', md: '14px', lg: '18px' }, lineHeight: { xs: '9px', sm: '15px', md: '21px', lg: '27px' }, textAlign: 'center', color: '#FFFFFF' }}>Seconds</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default TimeCounter;